import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("sml_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login" className="min-h-screen grid place-items-center bg-sml-forest px-5">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <span className="grid place-items-center h-11 w-11 rounded-sm bg-white text-sml-forest font-display font-semibold text-xl">S</span>
          <span className="font-display font-semibold text-white text-lg">SML Admin</span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-sm p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-sml-forest">
            <Lock className="h-5 w-5" />
            <h1 className="font-display text-2xl">Dashboard Login</h1>
          </div>
          <p className="mt-2 text-sm text-sml-charcoal/60">Sign in to view service enquiries.</p>

          <label className="block mt-6 text-sm font-medium text-sml-charcoal">Email</label>
          <input
            data-testid="admin-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full rounded-sm border border-sml-border px-4 py-3 outline-none focus:border-sml-forest focus:ring-2 focus:ring-sml-forest/20"
            placeholder="admin@smlpropertysolution.co.za"
          />

          <label className="block mt-5 text-sm font-medium text-sml-charcoal">Password</label>
          <input
            data-testid="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full rounded-sm border border-sml-border px-4 py-3 outline-none focus:border-sml-forest focus:ring-2 focus:ring-sml-forest/20"
            placeholder="••••••••"
          />

          {error && <p className="mt-4 text-sm text-destructive" data-testid="admin-error">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-sm bg-sml-forest text-white font-medium py-3.5 hover:bg-sml-green transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
